import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './prescriptions.settings';

const prescriptionSlice = createSlice({
  initialState: {
    prescriptionDetails: initialState
  },
  name: 'prescription',
  reducers: {
    resetPrescriptionDetails: () => ({ prescriptionDetails: initialState }),

    setPrescriptionDetails: (state, action) => {
      state.prescriptionDetails = action.payload;
    }
  }
});

export const { resetPrescriptionDetails, setPrescriptionDetails } = prescriptionSlice.actions;

export default prescriptionSlice.reducer;
